import Reveal from '../components/Reveal';
import SectionHead from '../components/SectionHead';
import InquiryForm from '../components/InquiryForm';
import { COMPATIBILITY_LIMITS } from '../content/products';
import { CONTACT } from '../content/site';
import usePageMeta from '../hooks/usePageMeta';

export default function Compatibility() {
  usePageMeta(
    'Request a Compatibility Review | RangeSafe Commercial Solutions',
    'RangeSafe knobs work with most stove models — not every stove. Submit your appliances for a compatibility review by the Commercial Solutions Team.'
  );
  return (
    <main className="pt-16">
      <header className="mx-auto max-w-shell px-5 pb-14 pt-20 sm:px-8 lg:pt-28">
        <SectionHead
          as="h1"
          eyebrow="Compatibility"
          lines={['Will it fit', 'our stoves?']}
          lead="RangeSafe knobs work with most stove models. Not every stove. A compatibility review checks your actual appliance list against the known fit considerations — a person reviews it, not an algorithm."
        />
      </header>

      <div className="mx-auto max-w-shell px-5 pb-16 sm:px-8">
        <div className="grid gap-px border border-line bg-line lg:grid-cols-3" data-testid="compatibility-limits">
          {COMPATIBILITY_LIMITS.map((lim, i) => (
            <Reveal key={lim.title} delay={i * 0.06} className="bg-base">
              <div className="h-full p-8">
                <p className="font-mono text-[11px] tracking-[0.3em] text-accentText">0{i + 1}</p>
                <h2 className="mt-3 font-display text-xl font-bold uppercase tracking-tight text-white">{lim.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-dim">{lim.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mx-auto grid max-w-shell gap-14 px-5 pb-24 sm:px-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <Reveal>
            <div className="border border-line bg-panel/40 p-6 sm:p-10" data-testid="compatibility-form-panel">
              <InquiryForm type="compatibility" submitLabel="Request a Compatibility Review" showCompatibilityFields />
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <aside className="space-y-8 lg:sticky lg:top-24">
            <div className="border border-line bg-panel p-7">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-mute">Good to know</p>
              <ul className="mt-5 space-y-4 border-t border-line2 pt-5 text-sm leading-relaxed text-dim">
                <li>Model numbers help but &ldquo;I don&rsquo;t know&rdquo; is a valid answer — the appliance brand and a photo of the control panel usually suffice.</li>
                <li>This is a review request. The Commercial Solutions Team responds with a fit assessment; there is no automated verdict.</li>
                <li>If uploads would help, the team will request them by reply. Please do not send photographs of residents or unrelated documents.</li>
              </ul>
            </div>
            <div className="border border-line p-7">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-mute">Direct contact</p>
              <p className="mt-4 font-mono text-sm text-white">
                <a href={`mailto:${CONTACT.generalEmail}`} className="hover:text-accent2" data-testid="compatibility-email">{CONTACT.generalEmail}</a>
              </p>
              <p className="mt-1 font-mono text-sm text-white">
                <a href={CONTACT.phoneHref} className="hover:text-accent2" data-testid="compatibility-phone">{CONTACT.phone}</a>
              </p>
            </div>
          </aside>
        </Reveal>
      </div>
    </main>
  );
}
